import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@web/components/ui/card";
import type { DailyStat } from "@repo/share-log-interfaces";
import {
  tooltipContentStyle,
  tooltipItemStyle,
  tooltipLabelStyle,
  legendStyle,
  formatKRW,
} from "../chart-styles";

interface DailyChartProps {
  data: DailyStat[];
}

const CURRENCY_UNIT_MAN = 10_000;
const CURRENCY_UNIT_CHEON = 1_000;
const CHART_HEIGHT_PX = 300;

const formatCurrency = (value: number): string => {
  if (value >= CURRENCY_UNIT_MAN) {
    return `${Math.round(value / CURRENCY_UNIT_MAN)}만`;
  }
  return `${Math.round(value / CURRENCY_UNIT_CHEON)}천`;
};

const formatDate = (date: string): string => {
  const d = new Date(date);
  return `${d.getMonth() + 1}/${d.getDate()}`;
};

export function DailyChart({ data }: DailyChartProps) {
  if (data.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>일자별 추이</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="h-75 flex items-center justify-center text-muted-foreground">
            데이터가 없습니다.
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>일자별 추이</CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={CHART_HEIGHT_PX}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="var(--border)" />
            <XAxis dataKey="date" tickFormatter={formatDate} fontSize={12} tick={{ fill: "var(--muted-foreground)" }} />
            <YAxis tickFormatter={formatCurrency} fontSize={12} tick={{ fill: "var(--muted-foreground)" }} />
            <Tooltip
              formatter={formatKRW}
              labelFormatter={(label) => `날짜: ${label}`}
              contentStyle={tooltipContentStyle}
              labelStyle={tooltipLabelStyle}
              itemStyle={tooltipItemStyle}
            />
            <Legend wrapperStyle={legendStyle} />
            <Line
              type="monotone"
              dataKey="expense"
              name="지출"
              stroke="var(--chart-expense)"
              strokeWidth={2}
              dot={false}
            />
            <Line
              type="monotone"
              dataKey="income"
              name="수입"
              stroke="var(--chart-income)"
              strokeWidth={2}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
